/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetK12DistrictsSummaryQueryResponse,
  GetK12DistrictsSummaryQueryParams,
} from '../types/GetK12DistrictsSummary'

function getGetK12DistrictsSummaryUrl() {
  const res = { method: 'GET', url: `/api/v1/k12/districts/summary/` as const }
  return res
}

/**
 * @summary K-12 districts list summary (count of filtered rows)
 * {@link /api/v1/k12/districts/summary/}
 */
export async function getK12DistrictsSummary(
  params?: GetK12DistrictsSummaryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetK12DistrictsSummaryQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetK12DistrictsSummaryUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
